import { StrictMode, useSyncExternalStore } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from '@/hooks/use-auth'
import { Toaster } from 'sonner'
import App from '@/src/App'
import ErrorBoundary from '@/src/ErrorBoundary'
import '@/app/_globals.css'

// Phone width = sonner's own full-width breakpoint. Bottom toasts covered dialog footers there.
const PHONE = '(max-width: 600px)'
function subscribePhone(cb: () => void) {
  const mq = window.matchMedia(PHONE)
  mq.addEventListener('change', cb)
  return () => mq.removeEventListener('change', cb)
}
function AppToaster() {
  const phone = useSyncExternalStore(
    subscribePhone,
    () => window.matchMedia(PHONE).matches,
    () => false,
  )
  return (
    <Toaster
      richColors
      position={phone ? 'top-center' : 'bottom-right'}
      toastOptions={{ actionButtonStyle: { minHeight: '44px', paddingLeft: '14px', paddingRight: '14px' } }}
    />
  )
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <App />
          {/* actionButtonStyle: sonner's action button is 24px tall by default,
              under the 44px touch target this repo requires of every interactive
              element. The client-delete Undo is the first and only `action:` toast
              in the app, so this affects that button and nothing else today.
              On a phone the toasts go to the top: at the bottom they covered dialog buttons. */}
          <AppToaster />
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>
)
